import moment from 'moment';
import { genderTypes } from '../../enums/genderTypes'
import { fetchStaticJson } from '../../utils/utils';
import { translateActions } from './translate-slice';

export const initTexts = () => {
    return async (dispatch, getState) => {
        try {
            const state = getState();
            const genderId = state.auth.userDetails?.genderId
            const studentkita = state.auth.user?.studentkita
            const lang = state.translate.lang

            let res = await fetchStaticJson(window.config.translationFile.replace('lang', lang))

            let myTexts = null;
            if (Object.keys(res).some(key => Object.values(genderTypes).includes(key))) { // support jsones without genders
                const genderText = res[genderTypes[genderId]] || {};
                const allText = res["all"] || {};
                const dottedText = (studentkita && window?.config?.dottedText?.includes(Number(studentkita)) && !localStorage.getItem("getHighSchoolApp")) ? { ...genderText["dotted"], ...allText["dotted"] } : {};
                myTexts = { ...allText, ...genderText, ...dottedText }
            }
            else
                myTexts = res

            dispatch(translateActions.initText({ texts: myTexts }))
        }
        catch {
            dispatch(translateActions.initText({ texts: {} }))
        }
    }
}

export const initLang = () => {
    return async (dispatch) => {
        try {
            let lang = localStorage.getItem("LANG");
            if (!lang) {
                lang = "he";
                localStorage.setItem("LANG", lang)
            }
            let direction = 'rtl';

            if (lang === 'he')
                await import('moment/locale/he')
            else if (lang === 'ar')
                await import('moment/locale/ar')

            moment.locale(lang);

            dispatch(translateActions.initLang({ lang: lang, direction: direction }))
        }
        catch {

        }
    }
}

export const changeLang = (lang) => {
    return async (dispatch) => {
        try {
            moment().locale(lang)
            localStorage.setItem("LANG", lang)
            window.location.reload();
        }
        catch {
        }
    }
}